import React from 'react'
import { object } from 'prop-types'
import styles from './UserPasswordPage.styl'
import { Success } from '../../components/Messages'
import { withContext } from '../../../utils/withContext'

class UserPasswordPage extends React.Component {

	static propTypes = {
		athlete: object,
		context: object
	}

	state = {
		success: false,
		password: '',
		repeatedPassword: ''
	}

	handlePasswordChange(e) {
		this.setState({ [e.target.name]: e.target.value })
	}

	handleSubmit(e) {
		e.preventDefault()
		const { password, repeatedPassword } = this.state
		password && repeatedPassword &&
			password === repeatedPassword &&
			fetch('/api/accounts/change_current_password', {
				method: 'POST',
				body: JSON.stringify({ password }),
				headers: {
					'Content-Type': 'application/json'
				},
				credentials: 'same-origin'
			})
				.then(() => {
					this.setState({ success: true }, () => {
						setTimeout(() => { this.setState({ success: false, password: '', repeatedPassword: '' }) }, 1000)
					})
				})
	}
	render() {
		const { password, repeatedPassword, success } = this.state
		return (
			<div>
				{ success ? <Success /> : null }
				<div className={ styles['content'] }>
					<h2 className={ styles['title'] }>Mudar password</h2>
					<form onSubmit={ this.handleSubmit.bind(this) }>
						<div className={ styles['dadosContainer'] }>
							<label>Nova Password</label>
							<input name="password" type="password" value={ password } onChange={ this.handlePasswordChange.bind(this) } />
						</div>
						<div className={ styles['dadosContainer'] }>
							<label>Repetir Nova Password</label>
							<input name="repeatedPassword" type="password" value={ repeatedPassword } onChange={ this.handlePasswordChange.bind(this) } />
						</div>
						<div className={ styles['submitButton'] }>
							<input type="submit" value="Submeter" />
						</div>
					</form>
				</div>
			</div>
		)
	}
}

export default withContext(UserPasswordPage)



// WEBPACK FOOTER //
// ./src/client/webapp/pages/UserPasswordPage/UserPasswordPage.js